<template>
  <v-fade-transition>
    <v-sheet style="background: #263238; color: white" absolute top right>
      <v-layout row align-center style="overflow: hidden; max-height: 80px;">
        <v-flex shrink pa-1>
          <v-btn-toggle dark class="ml-4" v-model="mode" slot="activator">
            <v-tooltip top>
              <v-btn large flat slot="activator" value="mouse">
                <v-icon>mouse</v-icon>
              </v-btn>
              <span>Vis koordinater fra musepeker</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn large flat slot="activator" value="input">
                <v-icon>edit</v-icon>
              </v-btn>
              <span>Skriv inn koordinater</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn large flat slot="activator" value="capture">
                <v-icon>location_searching</v-icon>
              </v-btn>
              <span>Klikk i kartet for å vise koordinater</span>
            </v-tooltip>
          </v-btn-toggle>
        </v-flex>
        <v-flex shrink pa-1>
          <v-select
            class="pl-4 mt-4"
            style="max-width: 300px;"
            item-value="name"
            :items="formats"
            v-model="selectedFormat"
            :return-object="true"
            dark
            item-text="name"
            solo
            dense
            flat
            @change="setCurrentlySelectedFormat"
          ></v-select>
        </v-flex>
        <v-flex shrink pa-1 v-if="mode == 'mouse' || mode == 'capture'">
          <div class="pa-0" style="float: left">
            <span style="font-size: 16px;">
              {{ message }}
              <v-btn v-clipboard="() => currentLocation" icon fab small dark>
                <v-icon style="font-size: 16px;">mdi-content-copy</v-icon>
              </v-btn>
              {{ currentElevation ? currentElevation + " moh." : "" }}
            </span>
          </div>
        </v-flex>

        <v-flex shrink pa-1 v-if="mode == 'input'">
          <v-text-field
            clearable
            dark
            v-model="inputCoordinate"
            :label="selectedFormat.currentPattern"
            solo
            flat
            class="mt-4"
          ></v-text-field>
        </v-flex>
        <v-flex shrink pa-1>
          <v-btn
            @click="goToInputLocation"
            :disabled="!inputCoordinate"
            fab
            small
            dark
            v-if="mode == 'input'"
          >
            <v-icon>search</v-icon>
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>

        <v-btn @click="close" fab small dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
    </v-sheet>
  </v-fade-transition>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
export default {
  name: "MapCoordinates",
  data: function() {
    return {
      coordinateConversionViewModel: null,
      currentLocation: null,
      currentElevation: 0,
      formats: [],
      inputCoordinate: null,
      elevationMoveTimeout: null,
      pointerMoveEventListener: null,
      pointerClickEventListener: null,
      elevationMapPoint: null,
      selectedFormat: null,
      coordinateGraphic: null,
      mode: "mouse"
    };
  },
  computed: {
    ...mapState(["is3D"]),
    message() {
      return this.currentLocation
        ? this.currentLocation
        : this.mode == "capture"
        ? "Klikk i kartet for å vise koordinater"
        : "Beveg pekeren over kartet for å vise koordinater";
    }
  },
  watch: {
    mode(val) {
      if (val == "capture") {
        this.currentLocation = "Klikk i kartet for å vise koordinater";
        this.coordinateConversionViewModel.mode = "capture";
        this.coordinateConversionViewModel.viewModel.mode = "capture";

        this.setShowPopupsOnClick(false);
      } else {
        this.setShowPopupsOnClick(true);
        this.coordinateConversionViewModel.mode = "live";
      }
      if (this.coordinateGraphic) {
        this.mapView.graphics.remove(this.coordinateGraphic);
        this.coordinateGraphic = null;
      }
    },
    mapView() {
      this.pointerMoveEventListener.remove();
      this.pointerClickEventListener.remove();
      this.coordinateConversionViewModel.view = this.mapView;

      this.mode = "mouse";

      this.pointerMoveEventListener = this.mapView.on(
        "pointer-move",
        function(event) {
          if (this.mode != "capture") {
            this.getElevation(event);
          }
        }.bind(this)
      );
      this.pointerClickEventListener = this.mapView.on(
        "click",
        function(event) {
          this.getElevation(event);
        }.bind(this)
      );
    }
  },
  methods: {
    ...mapActions(["deactivateTool"]),
    ...mapActions(["setShowPopupsOnClick"]),
    getElevation: function(event) {
      this.elevationMapPoint = this.mapView.toMap({
        x: event.x,
        y: event.y
      });
      if (this.elevationMoveTimeout) {
        clearTimeout(this.elevationMoveTimeout);
        this.elevationMoveTimeout = setTimeout(() => {
          this.elevationLayer
            .queryElevation(this.elevationMapPoint)
            .then(result => {
              this.currentElevation = result.geometry.z.toFixed(0);
            });
        }, 500);
      } else {
        this.elevationMoveTimeout = setTimeout(() => {
          this.elevationLayer
            .queryElevation(this.elevationMapPoint)
            .then(result => {
              this.currentElevation = result.geometry.z.toFixed(0);
            });
        }, 1000);
      }
    },
    setCurrentlySelectedFormat: function(evt) {
      loadModules([
        "esri/widgets/CoordinateConversion/support/Conversion"
      ]).then(
        function([Conversion]) {
          this.coordinateConversionViewModel.conversions.items[0] = new Conversion(
            {
              format: evt
            }
          );
        }.bind(this)
      );
    },
    goToInputLocation: function() {
      this.coordinateConversionViewModel
        .reverseConvert(
          this.inputCoordinate,
          this.coordinateConversionViewModel.conversions.items[0].format
        )
        .then(
          point => {
            this.coordinateConversionViewModel.currentLocation = point;
            loadModules(["esri/Graphic"]).then(
              function([Graphic]) {
                this.mapView.center = point;
                if (this.coordinateGraphic) {
                  this.mapView.graphics.remove(this.coordinateGraphic);
                  this.coordinateGraphic = null;
                }
                this.coordinateGraphic = new Graphic({
                  geometry: point,
                  symbol: this.coordinateConversionViewModel.locationSymbol
                });
                this.mapView.graphics.add(this.coordinateGraphic);
              }.bind(this)
            );
          },
          error => {
            console.error(error);
          }
        );
    },
    close: function() {
      this.setShowPopupsOnClick(true);
      this.mode = "mouse";
      this.mapView.graphics.remove(this.coordinateGraphic);
      this.coordinateConversionViewModel.mode = "live";
      document.getElementById("viewDiv").style.cursor = "auto";
      this.deactivateTool("coordinates");
    },
    loadCoordinates: function() {
      loadModules([
        "esri/widgets/CoordinateConversion",
        "esri/widgets/CoordinateConversion/support/Format",
        "esri/widgets/CoordinateConversion/support/Conversion",
        "esri/geometry/SpatialReference",
        "esri/geometry/Point"
      ]).then(
        function([
          CoordinateConversion,
          Format,
          Conversion,
          SpatialReference,
          Point
        ]) {
          // eslint-disable-next-line no-useless-escape
          let numberSearchPattern = /-?\d+[\.]?\d*/;
          this.coordinateConversionViewModel = new CoordinateConversion({
            view: this.mapView
          });

          this.pointerMoveEventListener = this.mapView.on(
            "pointer-move",
            function(event) {
              if (this.mode != "capture") {
                this.getElevation(event);
              }
            }.bind(this)
          );

          this.pointerClickEventListener = this.mapView.on(
            "click",
            function(event) {
              this.currentLocation = this.coordinateConversionViewModel.conversions.items[0].displayCoordinate;

              this.getElevation(event);
            }.bind(this)
          );

          let webMercator = new Format({
            name: "Lat/Long",
            conversionInfo: {
              spatialReference: new SpatialReference({ wkid: 4326 }),
              // eslint-disable-next-line no-unused-vars
              reverseConvert: function(string, format) {
                let parts = string.split(",");
                return new Point({
                  x: parseFloat(parts[0]),
                  y: parseFloat(parts[1]),
                  spatialReference: { wkid: 4326 }
                });
              }
            },
            coordinateSegments: [
              {
                alias: "X",
                description: "easting",
                searchPattern: numberSearchPattern
              },
              {
                alias: "Y",
                description: "northing",
                searchPattern: numberSearchPattern
              }
            ],
            defaultPattern: "Y, X"
          });

          let euref89 = new Format({
            name: "EUREF89 UTM33",
            conversionInfo: {
              spatialReference: new SpatialReference({ wkid: 25833 }),
              // eslint-disable-next-line no-unused-vars
              reverseConvert: function(string, format) {
                let parts = string.split(",");
                return new Point({
                  x: parseFloat(parts[0].match(numberSearchPattern)),
                  y: parseFloat(parts[1].match(numberSearchPattern)),
                  spatialReference: { wkid: 25833 }
                });
              }
            },
            coordinateSegments: [
              {
                alias: "X",
                description: "easting",
                searchPattern: numberSearchPattern
              },
              {
                alias: "Y",
                description: "northing",
                searchPattern: numberSearchPattern
              }
            ],
            defaultPattern: "Ø: X, N: Y"
          });

          let utm32 = new Format({
            name: "utm32",
            conversionInfo: {
              spatialReference: new SpatialReference({ wkid: 32632 }),
              // eslint-disable-next-line no-unused-vars
              reverseConvert: function(string, format) {
                let parts = string.split(",");
                return new Point({
                  x: parseFloat(parts[0].match(numberSearchPattern)),
                  y: parseFloat(parts[1].match(numberSearchPattern)),
                  spatialReference: { wkid: 32632 }
                });
              }
            },
            coordinateSegments: [
              {
                alias: "X",
                description: "Øst",
                searchPattern: numberSearchPattern
              },
              {
                alias: "Y",
                description: "Nord",
                searchPattern: numberSearchPattern
              }
            ],
            defaultPattern: "Ø: X, N: Y"
          });

          let utm33 = new Format({
            name: "utm33",
            conversionInfo: {
              spatialReference: new SpatialReference({ wkid: 32633 }),
              // eslint-disable-next-line no-unused-vars
              reverseConvert: function(string, format) {
                let parts = string.split(",");
                return new Point({
                  x: parseFloat(parts[0].match(numberSearchPattern)),
                  y: parseFloat(parts[1].match(numberSearchPattern)),
                  spatialReference: { wkid: 32633 }
                });
              }
            },
            coordinateSegments: [
              {
                alias: "X",
                description: "Øst",
                searchPattern: numberSearchPattern
              },
              {
                alias: "Y",
                description: "Nord",
                searchPattern: numberSearchPattern
              }
            ],
            defaultPattern: "Ø: X, N: Y"
          });

          let utm34 = new Format({
            name: "utm34",
            conversionInfo: {
              spatialReference: new SpatialReference({ wkid: 32634 }),
              // eslint-disable-next-line no-unused-vars
              reverseConvert: function(string, format) {
                let parts = string.split(",");
                return new Point({
                  x: parseFloat(parts[0].match(numberSearchPattern)),
                  y: parseFloat(parts[1].match(numberSearchPattern)),
                  spatialReference: { wkid: 32634 }
                });
              }
            },
            coordinateSegments: [
              {
                alias: "X",
                description: "Øst",
                searchPattern: numberSearchPattern
              },
              {
                alias: "Y",
                description: "Nord",
                searchPattern: numberSearchPattern
              }
            ],
            defaultPattern: "Ø: X, N: Y"
          });

          let utm35 = new Format({
            name: "utm35",
            conversionInfo: {
              spatialReference: new SpatialReference({ wkid: 32635 }),
              // eslint-disable-next-line no-unused-vars
              reverseConvert: function(string, format) {
                let parts = string.split(",");
                return new Point({
                  x: parseFloat(parts[0].match(numberSearchPattern)),
                  y: parseFloat(parts[1].match(numberSearchPattern)),
                  spatialReference: { wkid: 32635 }
                });
              }
            },
            coordinateSegments: [
              {
                alias: "X",
                description: "Øst",
                searchPattern: numberSearchPattern
              },
              {
                alias: "Y",
                description: "Nord",
                searchPattern: numberSearchPattern
              }
            ],
            defaultPattern: "Ø: X, N: Y"
          });

          let utm36 = new Format({
            name: "utm36",
            conversionInfo: {
              spatialReference: new SpatialReference({ wkid: 32636 }),
              // eslint-disable-next-line no-unused-vars
              reverseConvert: function(string, format) {
                let parts = string.split(",");
                return new Point({
                  x: parseFloat(parts[0].match(numberSearchPattern)),
                  y: parseFloat(parts[1].match(numberSearchPattern)),
                  spatialReference: { wkid: 32636 }
                });
              }
            },
            coordinateSegments: [
              {
                alias: "X",
                description: "Øst",
                searchPattern: numberSearchPattern
              },
              {
                alias: "Y",
                description: "Nord",
                searchPattern: numberSearchPattern
              }
            ],
            defaultPattern: "Ø: X, N: Y"
          });

          // Add our new format to the widget's dropdown
          this.coordinateConversionViewModel.formats.splice(0, 1);
          this.coordinateConversionViewModel.formats.splice(3, 3);

          this.coordinateConversionViewModel.formats.splice(6, 1);

          this.coordinateConversionViewModel.formats.add(webMercator);

          this.coordinateConversionViewModel.formats.add(euref89);
          this.coordinateConversionViewModel.formats.add(utm32);
          this.coordinateConversionViewModel.formats.add(utm33);
          this.coordinateConversionViewModel.formats.add(utm34);
          this.coordinateConversionViewModel.formats.add(utm35);
          this.coordinateConversionViewModel.formats.add(utm36);

          this.formats = this.coordinateConversionViewModel.formats.items;

          this.currentLocation = this.coordinateConversionViewModel.currentLocation;
          this.selectedFormat = euref89;
          this.coordinateConversionViewModel.conversions.items[0] = new Conversion(
            {
              format: euref89
            }
          );

          this.coordinateConversionViewModel.watch(
            "currentLocation",
            function() {
              this.currentLocation = this.coordinateConversionViewModel.conversions.items[0].displayCoordinate;
              if (this.mode === "capture") {
                if (this.coordinateGraphic) {
                  this.mapView.graphics.remove(this.coordinateGraphic);
                  this.coordinateGraphic = null;
                }
                setTimeout(() => {
                  this.currentLocation = this.coordinateConversionViewModel.conversions.items[0].displayCoordinate;
                  loadModules(["esri/Graphic"]).then(([Graphic]) => {
                    this.coordinateGraphic = new Graphic({
                      geometry: this.coordinateConversionViewModel
                        .currentLocation,
                      symbol: this.coordinateConversionViewModel.locationSymbol
                    });
                    this.mapView.graphics.add(this.coordinateGraphic);
                  });
                }, 500);
              }
            }.bind(this)
          );
        }.bind(this)
      );
    }
  },
  props: {
    mapView: Object,
    elevationLayer: Object
  },
  mounted() {
    this.loadCoordinates();
  }
};
</script>

<style>
.v-input__slot {
  background: transparent;
}
</style>
